<template>
  <label ref="inputContainer"
    class="mdc-text-field mdc-text-field--filled mdc-text-field--fullwidth mdc-text-field--no-label mdc-text-field--with-trailing-icon  mdc-elevation-transition"
    :class="{'mdc-text-field--disabled': disabled, 'empty': inputIsEmpty, 'show-icon': showIcon}"
    >

    <input ref="input"
      class="mdc-text-field__input"
      :type="type"
      :aria-label="label"
      @input='evt=>value=evt.target.value'
      :placeholder="placeholder"
      :name="name"
      :tabindex="tabindex"
      @keyup.enter="$emit('submitted')"
      v-model="value" />

    <i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" role="button"
      ref="icon"
      v-html="icon"
      @click="clear"
      :tabindex="nextTabindex(tabindex)"></i>

  </label>
</template>

<script>
import MdcTextFieldMixin from '../MdcTextFieldMixin'

export default {
  name: 'AccountsMdcTextField',
  mixins: [
    MdcTextFieldMixin
  ],
  methods: {
    getInputElement () {
      return this.$refs.input
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../scss/accounts.theme";

@import "@material/textfield/mdc-text-field";
@import "@material/textfield/icon/mdc-text-field-icon";
@import "@material/elevation/mdc-elevation";

.mdc-text-field.mdc-text-field--filled {
  @include mdc-elevation(1);

  @include mdc-text-field-ink-color($on-secondary);
  @include mdc-text-field-fill-color($secondary);
  @include mdc-text-field-shape-radius(4px);

  /* material mdc-text-field mixin does not support bottom radius */
  border-radius: 4px;
}
.mdc-text-field.empty {
  @include mdc-text-field-trailing-icon-color($secondary);
  @include mdc-text-field-caret-color($on-secondary);
}
.mdc-text-field.show-icon {
  @include mdc-text-field-trailing-icon-color(rgba(0, 0, 0, 0.54));
}
.mdc-text-field.mdc-text-field--focused {
  @include mdc-elevation(6);
  @include mdc-text-field-trailing-icon-color($on-secondary);
}
</style>
